import config from './config/config';

import Actions from './actions';
import Reducers from './reducers';
import Selectors from './selectors';

export default {
  Actions,
  Config: {
    stateKey: config.stateKey,
  },
  Selectors,
  Reducer: Reducers.rootReducer,
};
